<template>
  <v-container fluid>
      <v-row>
          <v-col cols=12>
              <v-card
                :loading="loading"
                :disabled="loading"
              >
                  <v-toolbar color="secondary" dark>
                    <v-toolbar-title>
                        <v-icon left>mdi-clipboard-text</v-icon>Invoices
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items class="hidden-sm-and-down">
                        <v-btn text @click="filters = !filters">{{filters ? 'Hide' :'Show'}} Filters</v-btn>
                        <download
                            url="invoices/export"
                            :data="{filters:filter}"
                            filename="invoices.xlsx"
                            label="Export List"
                        />
                    </v-toolbar-items>
                  </v-toolbar>
                  <v-card-text>
                    <v-card v-if="filters">
                        <v-card-text>
                            <v-row>
                                <v-col cols=3>
                                    <v-text-field v-model="filter.invoiceNumber" label="Invoice Number" clearable/>
                                </v-col>
                                <v-col cols=3>
                                    <v-text-field v-model="filter.orderId" label="#Order" clearable/>
                                </v-col>
                                <v-col cols=3>
                                    <v-select
                                        v-model="filter.statusId"
                                        :items="statuses"
                                        label="Status"
                                        multiple
                                        clearable
                                    />
                                </v-col>
                                <v-col cols=3>
                                    <shop-select
                                        v-model="filter.shopId"
                                        style="align-items:center"
                                    ></shop-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4">
                                    <v-menu
                                        ref="rangeMenu"
                                        v-model="rangeMenu"
                                        :close-on-content-click="false"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="filter.dateBetween"
                                                label="Date Range"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                            <v-date-picker
                                                v-model="filter.dateBetween"
                                                no-title
                                                scrollable
                                                range
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="rangeMenu = false">Cancel</v-btn>
                                                <v-btn text color="primary" @click="$refs.rangeMenu.save(date)">OK</v-btn>
                                            </v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn @click="fetchInvoices">Search</v-btn>
                        </v-card-actions>
                    </v-card>
                    <v-data-table
                        :items=invoices
                        :headers="headers"
                        :server-items-length="total"
                        :options.sync="options"
                    > 
                        <template #[`item.order.validationDate`]="{item}">
                            {{ item.order.validationDate | formatDate }}
                        </template>
                        <template #[`item.orderId`]="{item}">
                            {{ item.orderId }} <v-btn icon x-small :href="'/orders/view/' + item.orderId" target="_blank">
                                <v-icon>mdi-open-in-new</v-icon>
                            </v-btn>
                        </template>
                        <template #[`item.statusId`]="{item}">
                            <v-chip small :color="getInvoiceStatusColor(item.statusId)">{{item.statusId}}</v-chip>
                        </template>
                        <template #[`item.amount`]="{item}">
                            {{ item.amount | currency(item.order.currency) }}
                        </template>
                        <template #[`item.tax`]="{item}">
                            {{ item.tax | currency(item.order.currency) }}
                        </template>
                        <template #[`item.payouts`]="{item}">
                            {{ item.payouts.reduce((acc, payout) => payout.statusId=='close' ? acc + payout.amount : acc, 0) | currency(item.order.currency) }}
                        </template>
                    
                    
                    </v-data-table>
                </v-card-text>
              </v-card>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex'
import Download from "@components/Download";
import ShopSelect from "@components/forms/select/Shop.vue";
export default {
    name: 'InvoiceList',
    components:{
        Download,
        ShopSelect
    },
    data: () => ({
        rangeMenu:false,
        date:null,
        filters:false,
        filter:{},
        headers:[
            {text:'Invoice', value:'invoiceNumber'},
            {text:'Date', value:'order.validationDate'},
            {text:'#Order', value:'orderId'},
            {text:'Status', value:'statusId'},
            {text:'Amount TTC', value:'amount'},
            {text:'Tax', value:'tax'},
            {text:'Total Payouts', value:'payouts', sortable:false}
        ],
        statuses:[
            {id:'new', text:'New'},
            {id:'open', text:'Open'},
            {id:'paid', text:'Paid'},
            {id:'cancel', text:'Cancel'}
        ],
        options: { itemsPerPage: 15, sortBy: ["id"], sortDesc: [true] },
    }),
    computed:{
        ...mapGetters("invoices", [
            "invoices", "total", "loading"
        ])
    },
    filters:{
        formatDate (value, hour) {
            if (!value) return '';
            return hour ? moment(value).format('DD/MM/YYYY, HH:mm:ss') : moment(value).format('DD/MM/YYYY');
        }
    },
    watch:{
        options: {
            handler () {
                this.fetchInvoices();
            },
            deep: true
        }
    },
    methods:{
        ...mapActions("invoices", {getInvoices:'list', export:'export'}),
        fetchInvoices(){
            this.getInvoices({
                pagination: this.options,
                filters: this.filter
            })
        },
        getInvoiceStatusColor(status){
            switch (status) {
                case 'open':
                    return 'orange'
                case 'paid':
                    return 'green'
                case 'cancel':
                    return 'red lighten-3'
                default:
                    break;
            }
        },
        exportInvoices(){
            this.export({
                filters: this.filter
            })
        }
    }
}
</script>

<style>

</style>